import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseAutocompleteComponent } from '../base-autocomplete.component';

@Component({
  selector: 'boi-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AutocompleteComponent,
      multi: true
    }
  ]
})
export class AutocompleteComponent extends BaseAutocompleteComponent {
  @Input() public placeholder: string;
  @Input() public hasCustomItemTemplate = false;
  @Input() public readonly useObjectAsSelection: boolean = false;
  @Output() public readonly selectionChange = new EventEmitter();

  public onAutocompleteValueChange($event: any): void {
    if (this.useObjectAsSelection) {
      const objectToEmit = this.availableOptions.find((option) => option[this.valueField] === $event);
      this.selectionChange.emit(objectToEmit);

      return;
    }
    this.valueChange.emit($event);
  }
}
